import { placeAutocomplete, placeGeocodeReverse, placeDetails } from '@/store/api/place'

const GET_CURRENT_LOCATION_MAX_AGE = 60 * 60 * 1000
const GET_CURRENT_LOCATION_TIMEOUT = 5000

export const getAddress = (feature) => {
  if (feature.properties) {
    let firstLabel, secondLabel
    const address = feature.properties.name

    firstLabel = address.split(',')[0]

    const start = firstLabel.length
    const length = address.length

    secondLabel = address.substring(start, length).trim().replace(',', '')

    const payload = {
      address: feature.properties.name,
      description: feature.properties.name,
      short_address: feature.properties.name,
      place_id: feature.properties.place_id,
      adr_source: feature.properties.source || '',
      first_label: firstLabel,
      second_label: secondLabel
    }

    if (feature.type) {
      payload.types = [feature.type]
    }

    if (feature.geometry && feature.geometry.coordinates) {
      payload.geometry = feature.geometry

      payload.lat = feature.geometry.coordinates[1]
      payload.lng = feature.geometry.coordinates[0]
    }

    return payload
  }

  return null
}

/**
 *
 * @param {Object} params
 * @param {string} params.input
 * @param {string} params.lat
 * @param {string} params.lng
 * @param {'pelias' | 'google' | 'goong' | 'vietbando' | 'iot'} params.mode
 *
 * @param {Object} config
 * @param {Boolean} config.token_required
 * @returns {Array}
 */
export const getPlaceAutocomplete = (params, config = {}) => {
  return new Promise((resolve, reject) => {
    placeAutocomplete(params, config)
      .then((response) => {
        const data = response.data

        if (data && data.features) {
          let predictions = []

          data.features.forEach((feature) => {
            if (Array.isArray(feature)) {
              feature.forEach((j) => {
                const address = getAddress(j)
                if (address) predictions.push(address)
              })
            } else {
              const address = getAddress(feature)
              if (address) predictions.push(address)
            }
          })
          resolve(predictions)
        } else reject('INVALID_RESPONSE_DATA_FORMAT')
      })
      .catch((error) => reject(error))
  })
}

/**
 *
 * @param {Object} params
 * @param {string} params.place_id
 * @param {'pelias' | 'google' | 'goong' | 'vietbando' | 'iot'} params.src
 *
 * @param {Object} config
 * @param {Boolean} config.token_required
 * @returns {Array}
 */
export const getPlaceDetails = (params, config = {}) => {
  return new Promise((resolve, reject) => {
    placeDetails(params, config)
      .then((response) => {
        const data = response.data

        if (data && data.geometry) {
          if (data.geometry.location) {
            const coordinates = {
              lat: Number(data.geometry.location.lat) || null,
              lng: Number(data.geometry.location.lng) || null
            }
            return resolve(coordinates)
          }

          if (data.geometry.coordinates) {
            return resolve({
              lat: Number(data.geometry.coordinates[1]),
              lng: Number(data.geometry.coordinates[0])
            })
          }
        }

        return reject('INVALID_RESPONSE_DATA_FORMAT')
      })
      .catch((e) => reject(e))
  })
}

export const checkGeoLocationPermission = () => {
  return new Promise((resolve) => {
    // return true cause we cannot query permission
    if (!navigator.permissions || !navigator.permissions.query) return resolve(true)

    // return true cause exceed timeout
    setTimeout(() => {
      return resolve(true)
    }, 1000)

    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      if (result.state === 'denied') return resolve(false)

      return resolve(true)
    })
  })
}

export const getGeoLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return resolve()

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude
        const lng = position.coords.longitude

        if (!lat || !lng) return reject()

        return resolve({ lat, lng })
      },
      (error) => {
        return reject(error)
      },
      {
        enableHighAccuracy: true,
        maximumAge: GET_CURRENT_LOCATION_MAX_AGE,
        timeout: GET_CURRENT_LOCATION_TIMEOUT
      }
    )
  })
}

export const getPlaceGeoReverse = (input, config = {}) => {
  return new Promise((resolve, reject) => {
    let _config = {
      ...config,
      token_required_header: true,
      headers: {
        apikey: process.env.VUE_APP_WGEO_API_KEY
      }
    }
    placeGeocodeReverse({ ...input, profile: 'ahamove' }, _config)
      .then((response) => {
        const payload = response.data
        if (payload && payload.data) {
          let address = ''

          let item = payload.data.properties
          if (item) {
            address = item.address || item.name || ''
          }

          if (address)
            return resolve({
              formatted_address: address,
              address
            })
        }

        return reject('INVALID_RESPONSE_DATA_FORMAT')
      })
      .catch((error) => reject(error))
  })
}
